import { Component, Vue, Prop } from 'vue-property-decorator';
import { Field, TextField, Btn, FormButtonDisabler, IModalComponent, Validations } from '@samc/centricity-core';
import { IBuyer, IOrganization } from '@/Interfaces';

@Component({
  name: 'buyer-form-modal',
  components: { Field, TextField, Btn, FormButtonDisabler }
})
export default class BuyerFormModal extends Vue implements IModalComponent {
  @Prop() public addCloseProp!: (callback: () => Promise<IOrganization | undefined>) => void;
  @Prop() public closeProp!: () => void;

  public name: string = '';
  public moniker: string = '';
  public showValidations: boolean = false;
  public get validations(): Validations<{ name: string, moniker: string }> {
    let result: Validations<{ name: string, moniker: string }> = {}
    if (this.name.length == 0) {
      result.name = 'Counterparty Name is required!';
    }
    if (this.moniker.length == 0) {
      result.moniker = 'Counterparty Moniker is required!';
    }
    if (!result.hasOwnProperty('moniker') && this.moniker.length > 20) {
      result.moniker = 'Counterparty Moniker length can have maximum 20 characters!';
    }
    return result;
  }

  public mounted() {
    this.addCloseProp(async () => {
      this.showValidations = true;
      if (Object.keys(this.validations).length === 0) {
        return {
          name: this.name,
          moniker: this.moniker
        } as IOrganization
      }
    });
  }
}